<template>
    <div class="record-purchasecollectionentity">
        <PageTitle icon="fa fa-exchange" :main="purchasecollectionentity.name_entity" sub="Coleta de preços" />
        <b-form>
            <b-row>
                  <b-col md="3" sm="12">
                    <b-form-group
                        label="Condição:"
                        label-for="purchasecollectionentity-condition_payment_receipt_id"
                    >
                        <b-form-select
                            id="purchasecollectionentity-condition_payment_receipt_id"
                            size="sm"
                            :state="conditionPaymentReceiptState"
                            :options="conditionpaymentreceipts"
                            v-model="purchasecollectionentity.condition_payment_receipt_id"
                        />
                    </b-form-group>
                </b-col>
                 <b-col md="2" sm="12">
                    <b-form-group
                        label="Prazo de Entrega (Dias):"
                        label-for="purchasecollectionentity-deadline"
                    >
                        <b-form-input
                            id="purchasecollectionentity-deadline"
                            v-model="purchasecollectionentity.deadline"
                            type="number"
                            size="sm"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="7" sm="12">
                    <b-form-group
                        label="Local de Entrega:"
                        label-for="purchasecollectionentity-delivery_place"
                    >
                        <b-form-textarea
                            id="purchasecollectionentity-delivery_place"
                            :rows="2"
                            :max-rows="6"
                            size="sm"
                            v-model="purchasecollectionentity.delivery_place"
                            placeholder=""
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12">
                    <b-button
                        size="lq"
                        variant="dark"
                        title="Salvar registro"
                        class="fa fa-save"
                        @click="savePurchaseEntity"
                    >
                    </b-button>
                     <b-button
                        size="lq"
                        variant="dark"
                        title="Retornar tela de consulta"
                        class="ml-2 fa fa-reply"
                        @click="goback"
                    >
                    </b-button>
                </b-col>
               
            </b-row>    
        </b-form>
            <hr>
          <transition  
                    name="slide" 
                    type="animation" 
                    appear> 
                    <b-table 
                            class="table-responsive" 
                            hover key="slide" 
                            striped 
                            :items="purchasecollectionitems" 
                            :fields="fieldspurchasecollectionItem"> 
                        <template v-slot:cell(actions)="data">
                                   <b-button
                                    title="Editar"
                                    size="sm"
                                    variant="light"
                                    @click="openModalPurchaseCollectionItem(data.item)"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-edit"></i>
                                </b-button>
    
                        </template>
                    </b-table>
                </transition>

         <b-modal id="modalPurchaseCollectionItem"
            ref="modal"
            size="xl"
            title-tag = "h6"
            title="Item"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveCollectionItem"
            >
            <b-form>
                <b-row>
                    <b-col md="10" sm="10">
                        <b-form-group 
                            label="Descrição do Item:" 
                            label-for="purchasecollectionentityitem-complements_name">
                        <b-form-input 
                            id="purchasecollectionentityitem-complements_name" 
                            type="text"
                            v-model="purchasecollectionentityitem.complements_name"
                            size="sm"
                            :readonly= 'true'
                            placeholder="Nome..." />
                        </b-form-group>
                    </b-col>        
                    <b-col md="1" sm="2">
                        <b-form-group 
                            label="Unid:" 
                            abel-for="purchasecollectionentityitem-initials">
                        <b-form-input 
                            id="purchasecollectionentityitem-initials" 
                            type="text"
                            v-model="purchasecollectionentityitem.initials"
                            size="sm"
                            :readonly= 'true'
                            placeholder="Unid." />
                        </b-form-group>
                    </b-col> 
                </b-row>
                <b-row>
                     <b-col md="2" sm="12">
                        <b-form-group 
                            label="Qtde a Comprar:" 
                            label-for="purchasecollectionentityitem-quantity_available">
                        <b-form-input 
                            id="purchasecollectionentityitem-quantity_available" 
                            v-model="purchasecollectionentityitem.quantity_available" 
                            ref="focusEntryItemQuantity"
                            @input="ItemUnitFinalValue"
                            :readonly= 'true'
                            v-on:keyup.enter="focusModalEntryItemValueUnit"
                            type="number"
                            size="sm"
                            step="0.02"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                     <b-col md="2" sm="12">
                        <b-form-group 
                            label="Qtde Comprado:" 
                            label-for="purchasecollectionentityitem-quantity_purchase">
                        <b-form-input 
                            id="purchasecollectionentityitem-quantity_purchase" 
                            v-model="purchasecollectionentityitem.quantity_purchase" 
                            ref="focusEntryItemQuantity"
                            @input="ItemUnitFinalValue"
                            v-on:keyup.enter="focusModalEntryItemValueUnit"
                            type="number"
                            size="sm"
                            step="0.02"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                            <b-col md="2" sm="12">
                                <b-form-group 
                                    label="Valor Unitário:" 
                                    label-for="purchasecollectionentityitem-value_unit">
                                <b-form-input 
                                    id="purchasecollectionentityitem-value_unit" 
                                    v-model="purchasecollectionentityitem.value_unit" 
                                        ref="focusEntryItemValueUnit"
                                        @input="[ItemUnitFinalValue(),ItemUnitFinalValue()]"
                                        v-on:keyup.enter="focusModalEntryItemValueDesc"
                                        type="number"
                                        size="sm"
                                        step="0.02"
                                        pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                        />
                                    </b-form-group>
                            </b-col>
                            <b-col md="2" sm="12">
                                <b-form-group 
                                    label="Valor Desconto" 
                                    label-for="purchasecollectionentityitem-value_discount">
                                <b-form-input 
                                    id="purchasecollectionentityitem-value_discount" 
                                    v-model="purchasecollectionentityitem.value_discount" 
                                    @input="[ItemUnitFinalValue(),ItemUnitFinalValue()]"
                                    ref="focusEntryItemValueDesc"
                                    type="number"
                                    size="sm"
                                    step="0.02"
                                    pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col md="2" sm="12">
                                <b-form-group 
                                    label="Valor Total a Comprar:" 
                                    label-for="purchasecollectionentityitem-value_final">
                                <b-form-input 
                                    id="purchasecollectionentityitem-value_final" 
                                    v-model="purchasecollectionentityitem.value_final" 
                                    type="number"
                                    size="sm"
                                    :readonly= 'true'
                                    step="0.02"
                                    pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                    />
                                </b-form-group>
                            </b-col>
                             <b-col md="2" sm="12">
                                <b-form-group 
                                    label="Valor Total Comprado:" 
                                    label-for="purchasecollectionentityitem-value_final">
                                <b-form-input 
                                    id="purchasecollectionentityitem-value_final" 
                                    v-model="purchasecollectionentityitem.value_final" 
                                    type="number"
                                    size="sm"
                                    :readonly= 'true'
                                    step="0.02"
                                    pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                    <b-row>
                </b-row>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import { baseApiUrl , showError} from '@/global'
import axios from 'axios'
var moment = require('moment')

export default {
    name: 'RecordPurchaseCollection',
    components: { PageTitle},
    props:['purchasecollectionentity'],
    data: function() {
        return {
            
            conditionpaymentreceipts: [],
            purchasecollectionitems: [],
            purchasecollectionentityitem:{},
            entity_id:null,
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            perPage: 5,
            currentPage: 1,
            fieldspurchasecollectionItem:[
                    { key: "complements_name", label: "Descrição do Item", sortable:false }, 
                    { key: 'initials', label: 'Und.', sortable: false },       
                    { key: 'quantity_available', label: 'Requisitado', sortable: false },
                    { key: 'quantity_purchase', label: 'Comprado', sortable: false },
                    { key: 'value_unit', label: 'Vr.Unitário', sortable: false },
                    { key: 'value_discount', label: 'Vr.Desconto', sortable: false },
                    { key: 'value_final', label: 'Vr.Total', sortable: false },
                    { key: 'perc_ipi', label: '%IPI', sortable: false },
                    { key: 'perc_icms', label: '%ICMS', sortable: false },
                    { key: 'actions', label: 'Ações' , variant: 'light'},
            ],
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        compan() {
            return this.$store.state.compan
        },
        rows() {
            return this.entitys.length
        }
    },
    methods: {
        goback() {
            this.$router.go(-1, { query: 'q=s', hash: 'hashFrag' })
        },
        formatDate(date) {
            return moment.utc(date).format('YYYY-MM-DD')
        },
        ItemUnitFinalValue(){
            return this.purchasecollectionentityitem.value_final = parseFloat((parseFloat(this.purchasecollectionentityitem.value_unit ? this.purchasecollectionentityitem.value_unit : 0) - (this.purchasecollectionentityitem.value_discount ? this.purchasecollectionentityitem.value_discount : 0))).toFixed(2)
        },
         focusModalEntryItemQuantity(){
            this.$refs.focusEntryItemQuantity.focus()
        },
        focusModalEntryItemValueUnit(){
            this.$refs.focusEntryItemValueUnit.focus()
        },
        focusModalEntryItemValueDesc(){
            this.$refs.focusEntryItemValueDesc.focus()
        },
        loadConditionPaymentReceipt() {
            const url = `${baseApiUrl}/conditionpaymentreceipts`
            axios.get(url).then(res => {
                this.conditionpaymentreceipts = res.data.map(
                    conditionpaymentreceipt => {
                        return {
                            value: conditionpaymentreceipt.id,
                            text:
                            conditionpaymentreceipt.name_condition_payment_receipt
                        }
                    }
                )
            })
        },
        async loadpurchasecollectionsEntity(purchase_collection_id,entity_id) {

                const url = `${baseApiUrl}/purchasecollectionentitys/?purchase_collection_id=${purchase_collection_id}&entity_id=${entity_id}`
                await axios.get(url).then(res => {
                    this.purchasecollectionentity = res.data

                })
        },
        async loadPurchaseCollectionItems(){

            const url = `${baseApiUrl}/purchasecollectionentityitemidentitys/${this.purchasecollectionentity.purchase_collection_id}/?entity_id=${this.purchasecollectionentity.entity_id}`
            await axios.get(url).then(res => {
                this.purchasecollectionitems = res.data
   
            })
        },
        openModalPurchaseCollectionItem(item) {

            this.purchasecollectionentityitem = {...item}
            this.$bvModal.show('modalPurchaseCollectionItem')
        },
        async saveCollectionItem(){
            const method = 'put'
            await axios[method](`${baseApiUrl}/purchasecollectionentityitems/${this.purchasecollectionentityitem.id}`, this.purchasecollectionentityitem)
                    .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    })
                    .finally(async() => {
                      await  this.loadPurchaseCollectionItems()
                    })
                    .catch(showError)
        },
        async savePurchaseEntity(){

                const method = 'put'
                 const purchase_entity = {
                    id: this.purchasecollectionentity.id,
                    purchase_collection_id: this.purchasecollectionentity.purchase_collection_id,
                    collection_entity_company_id: this.compan.id,
                    entity_id: this.purchasecollectionentity.entity_id,
                    condition_payment_receipt_id: this.purchasecollectionentity.condition_payment_receipt_id,
                    delivery_place: this.purchasecollectionentity.delivery_place,
                    deadline: this.purchasecollectionentity.deadline,

                 } 

                await axios[method](`${baseApiUrl}/purchasecollectionentitys/${this.purchasecollectionentity.id}`, purchase_entity)
                    .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    })                    
                    .catch(showError)
        },
    },
    watch: {
        $route(to) {
           this.purchase_collection_id =  to.query.purchase_collection_id
           this.entity_id = to.query.entity_id

        }
    },
    async mounted() {
       await this.loadConditionPaymentReceipt()
       await this.loadPurchaseCollectionItems()
        // await this.loadpurchasecollectionsEntity(this.$route.query.purchase_collection_id,this.$route.query.entity_id)

    }
}
</script>

<style>



#modalPurchaseCollectionItem input {
    font-size: 0.7rem;
}

#modalPurchaseCollectionItem button {
    font-size: 0.7rem;
}

#modalPurchaseCollectionItem select {
    font-size: 0.7rem;
}


.record-purchasecollectionentity select,
label {
    font-size: 0.7rem;
}
.record-purchasecollectionentity input {
    font-size: 0.7rem;
}
.record-purchasecollectionentity button {
    font-size: 0.7rem;
}
.record-purchasecollectionentity h6 {
    font-size: 0.7rem;
}


@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
